import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Spread from './Spread';
import { useSpreadTypes } from '../../constants/readingTypes';
import { Button, Card, Drawer } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useCards from '@/hooks/useCards';
import { fullScreenButtonStyle } from '../../utils/buttonStyles';
import { track } from '@/third-party/MixPanel';
import ShuffleCards from '@/components/reading/ShuffleCards';
import { TarotCard } from '@/context/CardsContext';
import CardSelection from '@/components/reading/CardSelection';
import { Shuffle, Sparkles } from 'lucide-react';

const DisplayReading: React.FC = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { setSelectedReading, drawnCards, drawCards, setDrawnCards } = useCards();
    const [selectionDrawerOpen, setSelectionDrawerOpen] = useState(true);
    const [revealedDrawCards, setRevealedDrawCards] = useState<TarotCard[]>([]);
    const spreadTypes = useSpreadTypes();

    // Search through all categories to find the matching reading type
    const selectedReadingType = Object.values(spreadTypes)
        .flat()
        .find(type => type.id.toLowerCase() === id);


    // Draw cards when we have a selected reading type and no existing drawn cards
    useEffect(() => {
        setDrawnCards([]);
    }, []);

    // Initialize revealedDrawCards only when drawnCards change
    useEffect(() => {
        if (drawnCards.length > 0) {
            setRevealedDrawCards(drawnCards.map(card => ({
                ...card,
                visible: false
            })));
        }
    }, [drawnCards]);


    const readCards = async () => {
        track('spread_reading_started');
        navigate('/reading-cards');
    };
    const onSelectionComplete = (selectedCards: TarotCard[]) => {
        console.log('onSelectionComplete', selectedCards);
        setSelectionDrawerOpen(false);
        setDrawnCards(selectedCards);
        setRevealedDrawCards(selectedCards);
    }


    return (
        <div className="flex flex-col touch-none select-none pt-10" style={{ height: 'calc(100vh - 100px)' }}>
            <div className="flex-1 w-full max-w-2xl overflow-auto px-4">
                {selectedReadingType && (
                    <Spread
                        type={selectedReadingType}
                        cards={drawnCards}
                    />

                )}
            </div>
            <div className="w-full px-4 pb-4">
                <Button
                    variant="contained"
                    fullWidth
                    size="small"
                    onClick={readCards}

                    sx={{
                        fontFamily: '"Playfair Display", serif',
                        fontSize: '1.1rem',
                        textTransform: 'none',

                        borderRadius: 3,


                    }}
                >
                    <Sparkles className="w-5 h-5 mr-3" />
                    {t('readingPage.readCards')}
                </Button>
            </div>
            <Drawer
                anchor="bottom"
                open={selectionDrawerOpen}
                onClose={() => setSelectionDrawerOpen(false)}
                slotProps={{
                    paper: {
                        sx: {
                            height: '100%',

                            padding: '20px',

                        }
                    }
                }}
            >
                <CardSelection
                    maxSelections={selectedReadingType?.totalCards ?? 0}
                    onSelectionComplete={onSelectionComplete}
                />
            </Drawer>
        </div>
    );
};

export default DisplayReading;
